import {
defineCustomElement,
MediaQualityRadioGroupElement
} from "vidstack/elements";

defineCustomElement(MediaQualityRadioGroupElement);